import { FC } from "react";
import { Grid } from "@mui/material";

import { PageHeader } from "@dzambalaorg/mui-page-layout";
import {
  ClaimSection,
  DiscreteSection,
  DispenserSection,
  Erc1155Section,
  Erc20Section,
  Erc721Section,
  Erc998Section,
  MarketplaceSection,
  NativeSection,
  StakingSection,
  WaitListSection,
  ServiceType,
} from "@framework/shared";

import { Root } from "./styled";
// import { AssetPromoSection } from "./mechanics/promo";
import { AdminSection } from "./infrastructure";
// import { PonziSection } from "./mechanics/ponzi";
// import { MysterySection } from "./mechanics/mystery";

export const Dashboard: FC = () => {
  return (
    <Root>
      <PageHeader message="pages.dashboard.title" />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <NativeSection service={ServiceType.OFFICE} />
          <Erc20Section />
          <Erc721Section />
          <Erc998Section />
          <Erc1155Section />
          {/*<Divider sx={{ m: 2 }} />*/}
          {/*<MysterySection />*/}
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <DispenserSection />
          <WaitListSection />
          <ClaimSection />
          <DiscreteSection />
          {/*<AssetPromoSection />*/}
          <StakingSection />
          {/*<PonziSection />*/}
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <MarketplaceSection service={ServiceType.OFFICE} />
          <AdminSection />
        </Grid>
      </Grid>
    </Root>
  );
};
